import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import moment from 'moment'
import { WaterFlowPostDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/PreventiveWorkWaterSupply/WaterFlowSlice';


export default function WaterFlowPreventiveWorkPopup(props) {

    const { RoleID, handleOnCloseClick, open, Flag, handleIsPost, item, EditIcon, apiFlag, rowData, DashProjectTypeId } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [WaterFlowField, setWaterFlowField] = useState({
        readingDate: Flag === 'Update' ? moment(rowData.readingDate).format("YYYY-MM-DD") : '',
        wardName: Flag === 'Update' ? rowData.wardName : '',
        junctionDetails: Flag === 'Update' ? rowData.junctionDetails : '',
        locationDetails: Flag === 'Update' ? rowData.locationDetails : '',
        pipelineDetails: Flag === 'Update' ? rowData.pipelineDetails : '',
        flow: Flag === 'Update' ? rowData.flow : '',

    })

    const handleWaterFlowField = (e) => {
        setWaterFlowField({ ...WaterFlowField, [e.target.name]: e.target.value })
    }

    const handlePost = () => {
        const data = {
            T_WS_WaterFlowID: Flag === 'Update' ? rowData.t_wS_WaterFlowID : '0',
            T_Distri_WaterFlowID: Flag === 'Update' ? rowData.t_Distri_WaterFlowID : '0',
            Flow: WaterFlowField.flow,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }
        dispatch(WaterFlowPostDataAPI({ data }))

    }

    return (
        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="water_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Water Flow</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Date </b></label>
                                        <input type="date" className="form-control"
                                            id="exampleInputEmail1"
                                            name='readingDate'
                                            disabled
                                            aria-describedby="emailHelp"
                                            value={WaterFlowField.readingDate}
                                            onChange={(e) => handleWaterFlowField(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Ward Name </b></label>
                                        <input type="text" className="form-control"
                                            id="exampleInputEmail1"
                                            name='wardName'
                                            disabled
                                            aria-describedby="emailHelp"
                                            value={WaterFlowField.wardName}
                                            onChange={(e) => handleWaterFlowField(e)}
                                        />
                                    </div>
                                </div>

                                {
                                    (DashProjectTypeId == '6' && RoleID != '16') ?
                                        <>
                                            <div className="col-12 col-md-6 col-lg-6" >
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Location Name </b></label>
                                                    <input type="text" className="form-control"
                                                        name='junctionDetails'
                                                        disabled
                                                        aria-describedby="emailHelp"
                                                        value={WaterFlowField.locationDetails}
                                                        onChange={(e) => handleWaterFlowField(e)}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className="col-12 col-md-6 col-lg-6" >
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"><b>Junction Name </b></label>
                                                    <input type="text" className="form-control"
                                                        id="exampleInputEmail1"
                                                        name='junctionDetails'
                                                        disabled
                                                        aria-describedby="emailHelp"
                                                        value={WaterFlowField.junctionDetails}
                                                        onChange={(e) => handleWaterFlowField(e)}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                }




                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Pipe Size </b></label>
                                        <input type="text" className="form-control"
                                            name='pipeSize'
                                            disabled
                                            aria-describedby="emailHelp"
                                            value={WaterFlowField.pipelineDetails}
                                            onChange={(e) => handleWaterFlowField(e)}
                                        />
                                    </div>
                                </div>

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Flow Value </b></label>
                                        <input type="text" className="form-control"
                                            name='flow'
                                            aria-describedby="emailHelp"
                                            value={WaterFlowField.flow}
                                            onChange={(e) => handleWaterFlowField(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}